import { render, staticRenderFns } from "./costList.vue?vue&type=template&id=732a821c&scoped=true&"
import script from "./costList.vue?vue&type=script&lang=js&"
export * from "./costList.vue?vue&type=script&lang=js&"
import style0 from "./costList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./costList.vue?vue&type=style&index=1&id=732a821c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a821c",
  null
  
)

export default component.exports